<div class="full-page-container bg-primary">
  <img alt="" class="logo" src="assets/images/logo.png" draggable="false" />

  <div class="container">
    <div class="registration-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
